import { AxiosError } from 'axios'
import { appFetch } from '../store/reducer/app'
import { store } from '../store'
import { toast } from 'react-toastify'

export const showErrorMessage = (details: any, title?: string) => {
  const extractMessages = (data: any): string[] => {
    const parseNestedMessages = (value: any): string[] => {
      if (typeof value === 'string') {
        return [value]
      }
      if (Array.isArray(value)) {
        return value.flatMap((item) => parseNestedMessages(item))
      }
      if (value && typeof value === 'object') {
        return Object.values(value).flatMap((item) => parseNestedMessages(item))
      }
      return value === null || value === undefined ? [] : [String(value)]
    }

    if (typeof data === 'string') {
      return [data]
    } else if (Array.isArray(data)) {
      return data.map((item) => (typeof item === 'string' ? item : JSON.stringify(item)))
    } else if (data && typeof data === 'object') {
      if (data['json'] || data['query'] || data['_schema']) {
        const jsonMessages = data['json'] ? parseNestedMessages(data['json']) : []
        const queryMessages = data['query'] ? parseNestedMessages(data['query']) : []
        const schemaMessages = data['_schema'] ? parseNestedMessages(data['_schema']) : []
        return [...jsonMessages, ...queryMessages, ...schemaMessages]
      } else {
        return [JSON.stringify(data)]
      }
    } else {
      return [JSON.stringify(data)]
    }
  }

  const extractedMessages = details ? extractMessages(details) : []
  const errorMessages = extractedMessages.length > 0 ? extractedMessages : title ? [title] : ['Unknown error']

  if (errorMessages.length > 0) {
    toast(errorMessages.join('\n'), {
      type: 'error',
      position: 'top-center',
      style: {
        wordBreak: 'break-word',
        whiteSpace: 'pre-line',
        maxWidth: 400,
      },
    })
  }
}

export const customErrorResponse = async (error: AxiosError): Promise<any> => {
  const { response }: AxiosError = { ...error }
  if (response && response.data) {
    if (typeof response.data === 'string') {
      toast(response.data, {
        type: 'error',
        position: 'top-center',
        style: {
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
          maxWidth: 400,
        },
      })
    } else {
      const { details, error_code, title } = response.data as { details?: any; error_code?: string; title?: string }
      if (error_code || title || details) {
        const { status } = response
        if (status === 400 || status === 401 || status === 403 || status === 422 || status === 500) {
          if (error_code === 'ER-401-2') {
            await store.dispatch(appFetch())
          } else {
            showErrorMessage(details, title)
          }
        } else {
          toast(details ? JSON.stringify(details) : title || 'Unknown error', {
            type: 'error',
            position: 'top-center',
            style: {
              wordBreak: 'break-word',
              whiteSpace: 'pre-line',
              maxWidth: 400,
            },
          })
        }
      }
    }
  }
  console.error({ ...error })
  return Promise.reject({ ...error })
}
